import React from 'react';
import { Button, Result } from 'antd-mobile';
import { Navigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { UserRole, useAuthStore } from '../stores/auth.store';

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles?: UserRole[];
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, allowedRoles }) => {
  const location = useLocation();
  const { t } = useTranslation('common');
  const { isAuthenticated, user, logout } = useAuthStore((state) => ({
    isAuthenticated: state.isAuthenticated,
    user: state.user,
    logout: state.logout,
  }));

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (allowedRoles && user && !allowedRoles.includes(user.role)) {
    return (
      <div className="webview-page" style={{ display: 'flex', alignItems: 'center' }}>
        <Result
          status="warning"
          title={t('protectedRoute.forbiddenTitle')}
          description={t('protectedRoute.forbiddenDescription')}
        />
        <Button
          block
          color="primary"
          onClick={() => {
            logout();
            window.location.href = '/login';
          }}
        >
          {t('protectedRoute.backToLogin')}
        </Button>
      </div>
    );
  }

  return <>{children}</>;
};
